import classnames from 'classnames'
import { css } from 'emotion'
import { get } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'

import { Product } from 'even-ts-static'

import { formatImageUrl, getContrastingColor } from 'embed/utils'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { SpecialOffer } from 'embed/constants/models'

const commonStyles = require('embed/styles/results')
const styles = require('./styles')

export interface SpecialOfferListItemProps {
  bestOfferId?: string
  dispatchOfferCta: (loan: SpecialOffer) => void
  offer: SpecialOffer
  isResultsView?: boolean
  leadUuid?: string
  rateTableUuid?: string
}

class ListItem extends React.Component<SpecialOfferListItemProps> {
  el: HTMLLIElement

  render() {
    const { offer, dispatchOfferCta, isResultsView, rateTableUuid, leadUuid }: SpecialOfferListItemProps = this.props

    return (
      <ThemeConsumer>
        {({
          borderRadiusLarge,
          borderRadiusSmall,
          colorBorder,
          ctaStyles,
          colorSecondary,
          colorTextPrimary,
          fontFamilyPrimary,
        }) => (
          <li
            data-test-id="specialOffer"
            data-test-val={offer.uuid}
            className={classnames(
              commonStyles.offer,
              commonStyles.preApproved,
              css`
                border-color: ${colorBorder};
                border-radius: ${borderRadiusLarge};
              `,
            )}
            ref={(el: HTMLLIElement) => (this.el = el)}
          >
            <div className={classnames(commonStyles.column, commonStyles.originator)}>
              <img className={styles.partnerImage} src={formatImageUrl(get(offer, 'partnerImageUrl'))} />
              <p data-test-id="specialOffer_partnerName" className={classnames(styles.partnerName)}>
                {get(offer, 'partnerName')}
              </p>
            </div>
            <div className={classnames(commonStyles.column, styles.offerColumn)}>
              <div data-test-id="specialOffer_name" className={styles.offerTitle}>
                {offer.name}
              </div>
              <div data-test-id="specialOffer_desc" dangerouslySetInnerHTML={{ __html: offer.desc }} />
            </div>
            <div data-test-id="cta_ish" className={classnames(commonStyles.column, commonStyles.cta, styles.ctaColumn)}>
              <button
                className={classnames(
                  commonStyles.button,
                  css(`
                    color: ${getContrastingColor(ctaStyles?.backgroundColor, { black: colorTextPrimary })};
                    border-radius: ${borderRadiusSmall};
                    &:hover {opacity: 0.84;}
                  `),
                )}
                style={ctaStyles}
                onClick={dispatchOfferCta.bind(this, offer)}
              >
                Continue
              </button>
            </div>
            <div className={classnames(commonStyles.preApprovedSection, styles.specialOfferFlagContainer)}>
              <div
                data-test-id="specialOffer_flag"
                className={classnames(
                  commonStyles.preApprovedFlag,
                  css`
                    background-color: ${colorSecondary};
                    font-family: ${fontFamilyPrimary};
                    &::after {
                      border-color: ${colorSecondary};
                      border-right-color: transparent;
                    }
                  `,
                )}
              >
                Special Offer
              </div>
            </div>
          </li>
        )}
      </ThemeConsumer>
    )
  }
}

const mapStateToProps = (state) => ({
  leadUuid: get(state, `rates.${Product.Loan}.leadUuid`),
  rateTableUuid: get(state, `rates.${Product.Loan}.uuid`),
})

export const SpecialOfferListItem = connect(mapStateToProps)(ListItem)
